export const INVENTORY_DATA = {
    DELETE_INVENTORY_BTN: "delete-inventory-btn",
    ATS_REPORT_BTN: "ats-report-btn",
    DOWNLOAD_BTN: "inventory-download-btn",
    DOWNLOAD_INVENTORY_TEMPLATE: "download-inventory-template",
    DOWNLOAD_INVENTORY_TEMPLATE_XLSX: "download-inventory-template-xlsx",
    DOWNLOAD_INVENTORY_TEMPLATE_CSV: "download-inventory-template-csv",
    DIALOG: {
        INPUT_FIELD: "input-field",
    },
};
